// extracted by mini-css-extract-plugin
module.exports = {"Layout":"App_Layout__PvsOC","ContentContainer":"App_ContentContainer__32tgs","Sidebar":"App_Sidebar__2ItQJ","MainContent":"App_MainContent__3nN0H"};